import Swal from "sweetalert2";
const customSuccessAlert = (message) => {
  return Swal.fire({
    title: "SUCCESS",
    text: message,
    confirmButtonColor: "blue",
    confirmButtonText: "OK",
  });
};
export default customSuccessAlert;

